import { ShieldCheck } from '@phosphor-icons/react';
import {
  AlertDialog, AlertDialogContent, AlertDialogHeader, AlertDialogTitle,
  AlertDialogDescription, AlertDialogFooter, AlertDialogAction,
} from '../components/ui/alert-dialog';

const DISMISSED_KEY = 'foretour:homescreenTipDismissed';

function isStandalone() {
  return window.matchMedia('(display-mode: standalone)').matches
    || window.navigator.standalone === true;
}

/** Returns true if the tip should be shown (not standalone, not yet dismissed). */
export function shouldShowHomeScreenTip() {
  if (isStandalone()) return false;
  return localStorage.getItem(DISMISSED_KEY) !== 'true';
}

/**
 * One-time modal prompt recommending Home Screen install for reliable scoring.
 * Controlled externally via `open` prop — parent decides when to trigger.
 * After dismiss, sets localStorage flag so it never fires again.
 */
export default function ScoringHomeScreenTip({ open, onDismiss }) {
  const handleDismiss = () => {
    localStorage.setItem(DISMISSED_KEY, 'true');
    onDismiss();
  };

  return (
    <AlertDialog open={open} onOpenChange={() => {}}>
      <AlertDialogContent className="sm:max-w-sm rounded-2xl" onPointerDownOutside={(e) => e.preventDefault()}>
        <AlertDialogHeader>
          <div className="flex items-center gap-2.5">
            <div className="w-9 h-9 rounded-xl bg-[#1B4332] flex items-center justify-center flex-shrink-0">
              <ShieldCheck className="w-5 h-5 text-[#C9A227]" weight="fill" />
            </div>
            <AlertDialogTitle className="text-lg font-bold text-[#1D242B]">
              Add Fore Tour to your Home Screen
            </AlertDialogTitle>
          </div>
          <AlertDialogDescription className="text-sm text-[#455561] mt-2 leading-relaxed">
            Installing the app prevents session loss during a round, so your scores always save reliably.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogAction
            onClick={handleDismiss}
            className="w-full bg-[#1B4332] hover:bg-[#163B2B] text-white rounded-xl font-bold"
            data-testid="homescreen-tip-dismiss">
            Got it
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
